import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Field from '../common/FormField';
import styles from './common.module.css';

function LoginForm({ onChangeFactory, inProgress, error, onSubmit }) {
  const [showPassword, setShowPassword] = useState(false)

  return (
    <form
      id="login-form"
      className="smart-form client-form"
      noValidate
      onSubmit={event => {
        event.preventDefault()
        onSubmit(event)
      }}
    >
      <header>Sign In</header>
      <fieldset>
        <div className={styles.intro}>
          Sign in to the Gemsby Admin Portal.
        </div>

        {error && error.status === 401 && (
          <div className={styles.loginErrorMsg} role="alert">
            You have entered wrong email and/or password, please try again.
          </div>
        )}

        {error && error.message && error.status !== 401 && (
          <div className={styles.loginErrorMsg} role="alert">
            {error.message}
          </div>
        )}

        <Field type="input" name="Email" error={error.email}>
          <i className="icon-append fa fa-envelope" />
          <input
            type="text"
            name="email"
            placeholder="Enter your email"
            autoComplete="username"
            onChange={onChangeFactory('email')}
          />
        </Field>

        <Field
          type="input"
          name="Password"
          note={
            <Link to="/forgot-password">Forgot Password?</Link>
          }
          error={error.password}
        >
          <i
            className={`icon-append fa ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`}
            style={{ cursor: 'pointer' }}
            onClick={() => setShowPassword(v => !v)}
            title={showPassword ? 'Hide password' : 'Show password'}
          />
          <input
            type={showPassword ? 'text' : 'password'}
            name="password"
            placeholder="Enter your password"
            autoComplete="current-password"
            onChange={onChangeFactory('password')}
          />
        </Field>

        <Field type="checkbox">
          <input type="checkbox" defaultChecked />
          <i />Stay signed in
        </Field>
      </fieldset>

      <footer className={styles.footer}>
        <button
          type="submit"
          className={`btn btn-primary ${styles.submitButton}`}
          disabled={inProgress}
        >
          {inProgress ? 'Signing in...' : 'Sign in'}
        </button>
      </footer>
    </form>
  )
}

export default LoginForm
